<!--component html goes here -->
<!-- <div class="form-group addfile">
    <div class="input-group court" id="judge">
      <input type="file" name="file" id="file" class="file">
      <input type="text" name="file-name" placeholder="Opponent Advocate(s)" id="file-name" class="textbox form-control"
        readonly="readonly">
      <input type="button" class="btnfile savecls" value="ADD" (click)="addAdvicate()">
    </div>
  </div> -->

  <div class="form-group d-flex align-items-center justify-content-between">
  <label class="mb-0 fontbold">Opponent Advocate(s)  
  <i class="fa fa-plus-circle plus" aria-hidden="true" (click)="addAdvicate()"></i> 
  </label>
  </div>


<div *ngIf="enableAdvicate">
  <!-- <form [formGroup]="memberDetail" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="title" class="fontbold">Name 
      </label>
      <input type="text" class="form-control textbox" (input)="restricttextSpace($event)" id="name" name="name" placeholder="Name"
        formControlName="name" [(ngModel)]="name" [ngClass]="{'is-invalid':submitted && f.name.errors}">
      <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
        <div *ngIf="f.name.errors.required">Name is required</div>
        <div  *ngIf="f.name.errors?.alreadyExist">Name already exists</div>
      </div>
    </div>
    <div class="form-group">
      <label for="title" class="fontbold">Email Address
      </label>
      <input type="email" (input)="restricttextSpace($event)" class="form-control textbox" id="email" [(ngModel)]="email"  name="email" placeholder="Email Address"
        formControlName="email" [ngClass]="{'is-invalid':submitted && f.email.errors}" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">Email is required</div>
        <div *ngIf="!f.email.errors.required && !f.email.errors.alreadyExist">Email is invalid</div>
        <div  *ngIf="f.email.errors.alreadyExist">Email already exists</div>
      </div>
    </div>
    <div class="form-group">
      <label for="title" class="fontbold">Phone Number
      </label>
      <input type="tel" (input)="restricttextSpace($event)" (input)="restrictToNumbers($event)" class="form-control textbox" id="phone" [(ngModel)]="phone" name="phone" placeholder="Phone Number"
        formControlName="phone" minlength="10" maxlength="10" [ngClass]="{'is-invalid':submitted && f.phone.errors}">
      <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
        <div *ngIf="f.phone.errors.required">Phone number is required</div>
        <div *ngIf="!f.phone.errors.required && !f.phone.errors.alreadyExist">Phone number is invalid</div>
        <div  *ngIf="f.phone.errors.alreadyExist">Phone number already exists</div>
      </div>
    </div>
 
    <div class="btnbox"> 
    <button type="button" class="btn btn-default btncancel btnrightitem" (click)="onCancel()">Cancel</button>
    <button type="submit" class="btn btn-default btnsave savecls infoBtn" 
     [ngClass]="{'disabled-btn': memberDetail.invalid}" [disabled]="memberDetail.invalid" >Save</button>
    </div> 

  </form> -->

  <form class="formAl" [formGroup]="memberDetail" (ngSubmit)="onSubmit()">

  <div class="form-grid-3">
    <!-- Name -->
    <div class="form-group">
      <label class="fontbold">Name</label>
      <input type="text" class="form-control textbox"
        placeholder="Name"
        formControlName="name"
        [(ngModel)]="name"
        [ngClass]="{'is-invalid': submitted && f.name.errors}">
    </div>

    <!-- Email -->
    <div class="form-group">
      <label class="fontbold">Email Address</label>
      <input type="email" class="form-control textbox"
        placeholder="Email Address"
        formControlName="email"
        [(ngModel)]="email"
        [ngClass]="{'is-invalid': submitted && f.email.errors}">
    </div>

    <!-- Phone -->
    <div class="form-group phone-col">
      <label class="fontbold">Phone Number</label>
      <input type="tel" class="form-control textbox"
        placeholder="Phone Number"
        formControlName="phone"
        [(ngModel)]="phone"
        minlength="10" maxlength="10"
        [ngClass]="{'is-invalid': submitted && f.phone.errors}">
    </div>

    <!-- Buttons (under phone) -->
    <div class="btnbox btn-under-phone">
      <button type="button" class="btn btn-default btncancel" (click)="onCancel()">Cancel</button>
      <button type="submit" class="btn btn-default btnsave savecls infoBtn"
        [disabled]="memberDetail.invalid"
        [ngClass]="{'disabled-btn': memberDetail.invalid}">
        Save
      </button>
    </div>
  </div>

</form>


</div>
<div class="flex-container" *ngIf="advicate && advicate.length>0">
<div class="flexo" *ngFor="let item of advicate;let i=index">
<div class="opponent" [ngClass]="{'active':i==currentIndex}"> 
  <span> {{ item.name || item.email || item.phone }} </span>
  <span>  
        <i class="fa fa-edit"  [ngClass]="{'disabled-icon': isEditing}" (click)="editOpponente(item,i)"></i>
        <i class="fa fa-regular fa-circle-xmark calimg input-group-append xgrp" [ngClass]="{'disabled-icon': isEditing}" (click)="removeOpponente(item)"></i>
  </span>
</div>
</div>
</div>